const FAQs = {
  streamers: [
    [
      "What is Stream Loot?",
      "Stream Loot turns your Twitch donations and channel subscriptions into blockchain-based tokens and NFTs that viewers can collect and trade.",
    ],
    [
      "What is a 'Loot Set'?",
      "Your own customized set of blockchain-based stream rewards, mapped to your Twitch donations and channel subscriptions. Your viewers can claim their Loot after they support you on Twitch.",
    ],
    [
      "Can I customize my Loot Set?",
      "Yes. You decide which Twitch support events you want to translate to tokens and NFTs on-chain, what they're called, and what they look like. For example: a special NFT called 'POGYear' awarded to viewers who have subbed for 12 months",
    ],
    [
      "What is included in a standard Loot Set?",
      "Four items: one token/coin that maps to donations/bits, and three customizeable NFTs that map to different subscription tiers, streaks, or consecutive months.",
    ],
    [
      "Is this on the blockchain?",
      "Yes. When you mint your Loot Set, it becomes a decentralized smart contract on the Polygon blockchain.",
    ],
    [
      "Why bring Twitch donations and subs onto the blockchain?",
      "It makes supporting your stream feel more rewarding to viewers. They get something in return. And it's useful off-Twitch. For example: viewers can trade their Loot, show it off in profile pics, or you can use it as promotional items or tickets for off-Twitch events. The options are endless!",
    ],
    [
      "How do I create a Loot Set?",
      "Click or tap 'Launch App' to log into Twitch and begin customizing your set. Once you're happy with it, you can mint it on the blockchain. We will then log all donation and sub events for your viewers to claim their Loot. It's that easy!",
    ],
    [
      "Do I have to grant any channel permissions?",
      "To play around with customization, no. To mint your Loot Set on the blockchain, yes. Once minted, we need read access to your channel bits and subscriptions to log eligible Loot for your viewers. This is similar to StreamLab's permissions to show events in your overlays. We'll prompt you for access via Twitch login when you're ready to mint.",
    ],
    [
      "What does it cost?",
      "You're responsible for the initial Loot Set minting cost, which can range from $1-5 USD. Viewers are responsible for minting costs associated with their claimed Loot",
    ],
    [
      "How do my viewers earn Loot?",
      "Easy. They just donate and subscribe on Twitch as normal. We automatically reserve their Loot. Viewers can then mint their earned Loot on blockchain through our website.",
    ],
    [
      "Can Loot be traded?",
      "Yes. All Loot can be traded and sent between wallets on the blockchain.",
    ],
    [
      "Can Loot be sold?",
      "Yes. Your Loot Set token is compatiable with all ERC-1155 liquidity pools. Note: someone will need to provide initial liquidity to allow for buying and selling. NFTs are compatible with OpenSea and other NFT marketplaces.",
    ],
  ],
  viewers: [
    [
      "What is Stream Loot?",
      "Stream Loot turns your Twitch donations and channel subscriptions into blockchain-based tokens and NFTs that you can collect and trade.",
    ],
    [
      "Why bring Twitch donations and subs onto the blockchain?",
      "Why not get more for your support? On-Twitch benefits like emotes are great. But you can't take them with you. We want to bring that magic off-Twitch too. Earn real rewards, trade them, and show them off!",
    ],
    [
      "How do I earn Loot?",
      "Easy. Just donate and subscribe to your favorite streamers like normal. We'll keep track of what Loot you've earned. You can then mint your earned Loot on the Blockchain via our website. Then it's yours!",
    ],
    [
      "This is on the Blockchain?",
      "Yes. Once you mint your earned Loot, it exists on the blockchain. Fully decentralized, owned by the wallet you mint it to. You can send, trade, and show it off how ever you'd like.",
    ],
    [
      "How do I see my reserved Loot?",
      "Click or tap on the 'Launch App' button to see what Loot you've earned and what's waiting for you.",
    ],
    [
      "How do I mint my reserved Loot on the blockchain?",
      "Once authenticated via Twitch, you can mint your earned Loot via our website and Metamask or whichever browser-based wallet you use. We communicate directly with the Stream Loot smart contract on the blockchain and send the mint transaction for you.",
    ],
    [
      "What does it cost?",
      "Between $1-3 USD to mint your available Loot. Costs are variable based on network congestion and crypto prices.",
    ],
    [
      "Can Loot be traded?",
      "Yes. All Loot can be traded and sent between wallets on the blockchain.",
    ],
    [
      "Can Loot be sold?",
      "Yes. Your Loot Set token is compatiable with all ERC-1155 liquidity pools. Note: someone will need to provide initial liquidity to allow for buying and selling. NFTs are compatible with OpenSea and other NFT marketplaces.",
    ],
    [
      "What else can I do with my Loot?",
      "Streamers can do all sorts of creative things with their Loot Sets. NFTs could become tickets or access to special promotions, tokens could be used on eCommerce sites as payment or for special promotions, etc. You can also show off your Loot NFTs via any NFT curation, social media, or auction platform!",
    ],
  ],
};

export default FAQs;
